import React from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label} from "reactstrap";

const parseRow = row => ({
	...row,
	daysOfWeek: {
		lunes: row?.lunes,
		martes: row?.martes,
		miercoles: row?.miercoles,
		jueves: row?.jueves,
		viernes: row?.viernes,
		sabado: row?.sabado,
		domingo: row?.domingo,
	},
})

const Columns = ( addUpd, destroy,items,setItems,duplicateBranch,authUser,setModalDetail,modalDetail,day) => {
	console.log(day)
	const duplicate= (row) => {
		duplicateBranch(row).then(response => {
			if (response.status) {
				const newItem = response.branch;
				let array = [...items, newItem];
				array.sort((a, b) => {
					return a.id - b.id;
				});
				setItems(array);
			}
		})
	}

	let columns = [
	{
		id: 'day',
		name: 'Día',
		selector: row => day.name,
		sortable: true,
		wrap: true,
	},
	{
		id: 'time_start',
		name: 'Hora',
		selector: row => row.time_start,
		sortable: true,
		wrap: true,
	},
	{
		id: 'ramal_nombre',
		name: 'Ramal',
		selector: row => row.branch?.name,
		sortable: true,
		wrap: true,
	},
	{
		id: 'tiempo',
		name: 'Tiempo',
		selector: row => row.tiempo,
		sortable: true,
		wrap: true,
	},
	{
		id: 'unit_name',
		name: 'Unidad',
		selector: row => row.unit?.number,
		sortable: true,
		wrap: true,
	},
	{
		id: 'operator_name',
		name: 'Operador',
		selector: row => row.operator?.name,
		sortable: true,
		wrap: true,
	},
	{
		id: 'destination',
		name: 'Destino',
		selector: row => row.destination,
		sortable: true,
		wrap: true,
	},
	{
		id: 'actions',
		name: 'Acciones',
		width:'15%',
		button: true,
		cell: row => (
			<div className="d-flex justify-content-between">
				<div className="p-2">
					<button className="btn btn-info btn-sm" title='Detalle Salida' onClick={() => setModalDetail({...modalDetail,show:true,id:row.id,title:`Salida ${row.id} - ${row.destination}`})}><i className="fa fa-eye"></i></button>
				</div>
				<div className="p-2">
					<button className="btn btn-warning btn-sm" title='Editar Salida' onClick={() => addUpd(parseRow(row))}><i className="fas fa-edit"></i></button>
				</div>
				<div className="p-2">
					<button className="btn btn-danger btn-sm" title='Eliminar Salida' onClick={() => destroy(row.id)}><i className="fas fa-trash"></i></button>
				</div>
			</div>
			),
		}

		];
		return columns;
	}

	export default Columns;

//vaneton beicli